/**
 * BidetNY's dependency-free operational policy configuration.
 *
 * Keep units in export names so callers do not need local interpretations or
 * conversion constants. This module must remain safe to import in browsers,
 * server-side rendering, Netlify Functions, and generated document builders.
 */

// T125 consumes this in server-side no-show enforcement when that workflow lands.
// The shipped installer flow currently waits 30 minutes; T159 centralizes that
// live value without changing the policy to T125's proposed 15 minutes.
export const NOT_HOME_WAIT_MINUTES = 30;

export const INSTALL_SLOT_LENGTH_HOURS = 2;

export const BOOKING_HORIZON_WEEKS = 6;

export const SERVICE_HOURS = {
  startHour: 7,
  endHour: 19,
} as const;

export const RESCHEDULE_LOCK_HOURS = 24;

export const MONEY_BACK_GUARANTEE_DAYS = 14;

// T123 will consume this when late-delivery risk detection lands. Its current
// spec proposes that the product arrive at least one day before installation.
export const LATE_RISK_DELIVERY_BUFFER_DAYS = 1;

export const SALES_TAX_RATE = 0.08875;

// T59 will consume this after the percentage is decided. Planning currently
// conflicts (15% proposed in task state, 20% in the thesis), so null makes the
// unresolved policy explicit rather than silently choosing one.
export const PRODUCT_PRICE_VARIABILITY_CAP_PERCENT: number | null = null;
